// import Lottie from "lottie-react";
// import spinnerLottie from "img/spinner.json";
import { SyncLoader } from "react-spinners";
import { CSSProperties } from "react";
import Util from "../Util";

const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
};
export type spinnerType = "1" | "2";
interface SpinnerProps {
    loading: boolean
    loadingDim: boolean
    dimOpacity?: number
    spinnerType?: spinnerType
}
function Spinner({loading, loadingDim, dimOpacity, spinnerType}: SpinnerProps) {
    return (
        <div style={{
            display: (loading ? "flex" : "none"),
            backgroundColor: loadingDim ? ("rgba(182, 182, 182, " + (Util.isEmpty(dimOpacity) ? "1.0" : dimOpacity) + ")") : "",
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 99,
            animation: "modal-bg-show 0.3s"
        }}>
            <div style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            }}>
                {/* <Lottie animationData={spinnerLottie} /> */}
                {!spinnerType || spinnerType === "1" ?
                    <SyncLoader
                        color={"black"}
                        loading={loading}
                        cssOverride={override}
                        size={30}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                : <></>}
                {spinnerType === "2" ?
                    <img src={Util.getImgSrc("common/spinner_rainbow.gif")} alt="spinner_new" className="usN" style={{width: 150}} />
                : <></>}
            </div>
        </div>
    );
}
export default Spinner;